///<reference path="../Typings/jquery.d.ts"/>

declare var details;
declare var jssorSliderInit, MerlinQtipGallery;

class MerlinFullscreenGallery {
    private $spinner: JQuery = $(MerlinGalleryUtils.spinner);
    private $closeBtn: JQuery = $('<i class="btn-gallery-close fa fa-times fa-3x text-color-5"></i>');

    private uid: number = Math.floor(Math.random() * 26) + Date.now();
    private $fsContainer: JQuery = $('<div id="merlin-gallery-fullscreen"></div>').attr('data-id', this.uid);
    private $fsimageContainer: JQuery = $('<div class = "mg-fs-image-container br-block"></div>');
    private $fsNavBtnLeft: JQuery = $(MerlinGalleryUtils.btnWrapper).addClass('pull-left').append($(MerlinGalleryUtils.navBtnLeft).addClass('fa-3x').css('left', '15px'));
    private $fsNavBtnRight: JQuery = $(MerlinGalleryUtils.btnWrapper).addClass('pull-right').append($(MerlinGalleryUtils.navBtnRight).addClass('fa-3x').css('right', '15px'));

    private $lastFsImage: JQuery;
    private lastFsImageWidth: number;
    private lastFsImageHeight: number;
    private lastFsImageIndex: number;

    private $tempImage: JQuery;
    private spinnerTimeout;
    private imageList: Array<string>;
    private merlinGallery: MerlinQtipGallery = null;

    private $fsInitElementContainer: JQuery;

    //binded handlers
    private keyDownHandlerFunction = this.keyDownHandler.bind(this);

    /**
     creates event listeners for elements that trigger fullScreen gallery
     @param $initElementsContainer container with elements that trigger fullscreen gallery
     */
    constructor($initElementsContainer: JQuery, imageList: Array<string>, onTopOf: JQuery = null) {
        var triggerElementClass: string = '.mg-image-container';

        this.$fsInitElementContainer = $initElementsContainer;
        this.imageList = imageList;
        this.$fsContainer.append(this.$fsNavBtnLeft, this.$fsNavBtnRight, this.$closeBtn, this.$fsimageContainer);
        var _this = this;

        if ($initElementsContainer.is('.mg-image-container')) {
            triggerElementClass = '';
            $initElementsContainer.prepend(MerlinGalleryUtils.zoomInBtn).css('cursor', 'pointer');
        }
        else
            $initElementsContainer.find('img').css('cursor', 'pointer').before(MerlinGalleryUtils.zoomInBtn);

        if (onTopOf) {
            var zIndexes: Array<number> = [];

            $.each(onTopOf, (index, element) => {
                var $index = Number($(element).css('z-index'));

                if ($index > 0) {
                    zIndexes.push($index);
                }
                else {
                    zIndexes.push(element.style.zIndex); // only inline styles
                }
            });

            zIndexes.sort(function (a, b) {
                return a - b
            });

            this.$fsContainer.css('z-index', (zIndexes[0] + 2));
        }

        $initElementsContainer
            .on(MerlinGalleryUtils.pointerEventType, triggerElementClass, (e, oldEvent) => {
                if (oldEvent) {
                    oldEvent.stopPropagation();
                    oldEvent.preventDefault();
                }

                var $clickedElement = $(e.target);
                var $element = $(e.currentTarget).closest('.object-listing-elem');
                var htlCode = $element.attr('data-ofr_id');
                var htlTourop = $element.attr('data-ofr_tourOp');
                var title = $element.find('.offer-title').html();


                if (!$clickedElement.is('.mg-image-container'))
                    $clickedElement = $clickedElement.closest('.mg-image-container');

                var selectedImage = $clickedElement.attr('data-index');

                if($clickedElement.closest('.booking').length > 0)
                {
                    if(null === this.merlinGallery)
                    {
                        this.merlinGallery = new MerlinQtipGallery();
                    }

                    this.merlinGallery.additionalDataQtip(title, htlCode, htlTourop, 'gallery', selectedImage);
                }
                else
                {
                    this.showFullscreen($clickedElement.attr('data-index'));
                }
            });

        if (MerlinGalleryUtils.pointerEventType != 'tap') {
            $initElementsContainer
                .on('mouseover', triggerElementClass, function (e) {
                    $(this).find('.btn-zoom-in').show();
                })
                .on('mouseout', triggerElementClass, function (e) {
                    $(this).find('.btn-zoom-in').hide();
                })
        }
        else {
            this.$fsContainer
                .on('touchstart touchmove touchend', function (e) {
                    e.preventDefault();
                })
                .on('swipe', (e) => {
                    if (e['direction'] === 'left') {
                        this.prevImage(e, null);
                    }
                    else if (e['direction'] === 'right') {
                        this.nextImage(e, null);
                    }
                });
        }
    }

    public cleanUp(): void {
        this.$fsInitElementContainer.off();
        this.$fsContainer.off();
    }

    private showFullscreen(galleryIndex: string): void {
        $(window).on('keydown', this.keyDownHandlerFunction);

        this.lastFsImageIndex = Number(galleryIndex);

        $('body').append(this.$fsContainer).css('overflow', 'hidden');
        this.loadImage();

        this.$fsContainer.on(MerlinGalleryUtils.pointerEventType, (e, oldEvent) => {
            if (oldEvent) {
                oldEvent.stopPropagation();
                oldEvent.preventDefault();
            }

            if ($(e.target).is('.btn-gallery-close')) {
                this.hideGallery();
                this.$fsContainer.off(MerlinGalleryUtils.pointerEventType);
                this.$lastFsImage = undefined;
            }

            if ($(e.target).closest('.gallery-fs-image-container').length) {
                e.preventDefault();
                e.stopPropagation();
            }
            else {
                this.hideGallery();
                this.$fsContainer.off(MerlinGalleryUtils.pointerEventType);
                this.$lastFsImage = undefined;
            }
        });
        this.$fsNavBtnLeft.on(MerlinGalleryUtils.pointerEventType, this.prevImage.bind(this));
        this.$fsNavBtnRight.on(MerlinGalleryUtils.pointerEventType, this.nextImage.bind(this));
    }

    private nextImage(e, oldEvent): void {
        if (oldEvent) {
            oldEvent.stopPropagation();
            oldEvent.preventDefault();
        }
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        this.lastFsImageIndex++;
        if (this.lastFsImageIndex == this.imageList.length)
            this.lastFsImageIndex = 0;

        this.loadImage();
    }

    private prevImage(e, oldEvent): void {
        if (oldEvent) {
            oldEvent.stopPropagation();
            oldEvent.preventDefault();
        }

        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        this.lastFsImageIndex--;
        if (this.lastFsImageIndex == -1)
            this.lastFsImageIndex = this.imageList.length - 1;

        this.loadImage();
    }

    private hideGallery(): void {
        if (this.$lastFsImage)
            this.$lastFsImage.remove();
        this.$fsContainer.detach();
        $('body').css('overflow', '');
        this.$fsNavBtnLeft.off(MerlinGalleryUtils.pointerEventType);
        this.$fsNavBtnRight.off(MerlinGalleryUtils.pointerEventType);
        $(window).off('keydown', this.keyDownHandlerFunction);
    }

    private loadImage(): void {
        if (this.$lastFsImage)
            this.$lastFsImage.attr('src', '');
        this.$tempImage = $('<img src="' + this.imageList[this.lastFsImageIndex] + '">');
        clearTimeout(this.spinnerTimeout);
        this.spinnerTimeout = setTimeout(() => {
			this.$fsimageContainer.append(this.$spinner);
        }, 200);
        //$.ajax
        this.$tempImage.unbind('load').load(() => {
            clearTimeout(this.spinnerTimeout);
            if (this.$lastFsImage)
                this.$lastFsImage.remove();

            this.$spinner.detach();
            this.$fsimageContainer.append(this.$tempImage);
            this.$lastFsImage = this.$tempImage;
            this.lastFsImageWidth = this.$lastFsImage.width();
            this.lastFsImageHeight = this.$lastFsImage.height();
        });
    }

    private keyDownHandler(e): void {
        e.preventDefault();
        e.stopPropagation();

        var key = e.which;
        if (key == 37) {
            this.prevImage(null, null);
        }
        else if (key == 39) {
            this.nextImage(null, null);
        }
        else if (key == 27) {
            this.hideGallery();
        }
    }
}

class MerlinContentGallery {
    private $spinner: JQuery = $(MerlinGalleryUtils.spinner);

    private $galleryImageContainer: JQuery = $('<div class="mg-image-container big-image text-center">');
    private $galleryImage: JQuery = $('<img>');
    private $galleryContainer: JQuery;
    private $galleryScrollPane: JQuery = $('<div class="gallery-scroll-pane">');
    private $galleryContent: JQuery = $('<div class="gallery-content">');
    private $galleryNavBtnLeft: JQuery = $(MerlinGalleryUtils.navBtnLeft).addClass('fa-2x').css('float', 'left');
    private $galleryNavBtnRight: JQuery = $(MerlinGalleryUtils.navBtnRight).addClass('fa-2x').css('float', 'right');
    private $lastGalleryImage: JQuery;
    private $mobileView: JQuery;
    private $galleryMobileContent: JQuery = $(".gallery-mobile-content");

    private galleryViewWidth: number;
    private galleryLength: number;
    private previewList: Array<string>;
    private thumbnailsList: Array<string>;
    private thumbWidth: number = 65; // app/sass/base/merlin-utils/_merlin-gallery.scss - thumbnail-box width
    private thumbMargin: number = 7; // app/sass/base/merlin-utils/_merlin-gallery.scss - thumbnail-box margin
    private totalThumbWidth: number = this.thumbWidth + this.thumbMargin;

    private hasFullscreen: boolean;

    private $navBtnLeft: JQuery = $(MerlinGalleryUtils.btnWrapper).addClass('prev-image').append($(MerlinGalleryUtils.navBtnLeft).addClass('fa-3x'));
    private $navBtnRight: JQuery = $(MerlinGalleryUtils.btnWrapper).addClass('next-image').append($(MerlinGalleryUtils.navBtnRight).addClass('fa-3x'));

    constructor($galleryElement: JQuery, hasFullscreen: boolean = false, hasNavBtns: boolean = false) {
        this.$galleryContainer = $galleryElement;
        this.hasFullscreen = hasFullscreen;
        this.$galleryImageContainer.append(this.$galleryImage);
        this.$galleryContainer.append(this.$galleryNavBtnLeft.addClass('disabled'), this.$galleryNavBtnRight, this.$galleryScrollPane.append(this.$galleryContent));

        this.$galleryContainer.before(this.$spinner, this.$galleryImageContainer).parent().addClass('merlin-gallery-container');

        if (hasNavBtns) {
            this.$galleryContainer.before(this.$navBtnLeft, this.$navBtnRight);
        }
    }

    public loadGallery(ajaxUrl: string, alternativeUrl: string, callback: any = undefined, callbackObjectName: string = '', onTopOf: JQuery = null, selectedImage: JQuery = null): void {
        $.ajax({
            dataType: "json",
            type: "POST",
            url: ajaxUrl,
            success: (result) => {
                var $allElements = $();
                var html = '';
                var slectedImageId = selectedImage === null ? 0 : selectedImage;

                // TODO: Usunac zaleznosc od jakies zmiennej globalnej
                if (typeof details === 'undefined') {
                    var details = {
                        obj_country: '',
                        obj_name: ''
                    };
                }

                if(!$.isEmptyObject(result)){
                    this.$galleryContent.data('postResult', result)
                }

                if (result.thumbs && result.thumbs.length) {
                    this.$spinner.detach();
                    $.each(result.thumbs, function (index, element) {
                        $allElements = $allElements.add('<div class="thumbnail-box"><img data-original="' + element + '"/></div>');
                    });

                    this.galleryViewWidth = this.$galleryContent.width();
                    this.$lastGalleryImage = $($allElements.get(slectedImageId)).addClass('active');
                    this.$galleryContent.empty().append($allElements);
                    this.$galleryContent.find('img').lazyload({
                        container: this.$galleryScrollPane,
                        skip_invisible: true
                    });
                    this.galleryLength = result.thumbs.length * this.totalThumbWidth;

                    this.$galleryImage.attr('src', result.fullpics[slectedImageId]).attr('alt', details.obj_country + " - " + details.obj_name).parent('').attr('data-index', slectedImageId);

                    if (this.galleryLength - this.galleryViewWidth > 0)
                        this.$galleryNavBtnLeft.add(this.$galleryNavBtnRight).show();
                    if (this.hasFullscreen)
                        var fsGallery = new MerlinFullscreenGallery(this.$galleryImageContainer, result.fullpics, onTopOf);

                    this.previewList = result.fullpics;
                    this.thumbnailsList = result.thumbs;
                    this.addGalleryListeners();

                    for (var item of result.pics) {
                        html += '<div data-p="100.50" style="display: none;">' +
                            '<img data-u="image"  src2="' + item + '" alt="' + details.obj_country + '">' +
                            '</div>';
                    }
                    this.$galleryMobileContent.append(this.$mobileView).append(html);

                    $(window).on('resize.mobileGallery', MerlinContentGallery.initMobileGallery);
                    MerlinContentGallery.initMobileGallery();

                } else {
                    this.$spinner.detach();
                    this.$galleryContent.empty();
                    this.galleryLength = 0;
                    this.$galleryImage.attr('src', alternativeUrl);
                }

                if (callbackObjectName) {
                    if (callbackObjectName.indexOf(',') === -1) {
                        callback(result[callbackObjectName]);
                    }
                    else {
                        let returnName = callbackObjectName.split(','),
                            returnObj = {};

                        for (var ii = 0; ii < returnName.length; ii++) {
                            returnObj[returnName[ii]] = result[returnName[ii]];
                        }

                        callback(returnObj);
                    }
                }
            },
            error: () => {
                console.log('error');
                this.$spinner.detach();
                this.$navBtnLeft.detach();
                this.$navBtnRight.detach();
                this.$galleryContent.empty();

                if (callback) {
                    callback(null);
                }
            }
        });
    }

    private static initMobileGallery(): void {
        if ($('#jssor_1:visible').length) {
            $(window).off('resize.mobileGallery');
            jssorSliderInit();
        }
    }

    private addGalleryListeners(): void {
        var lastPosition: number;
        this.$galleryContainer
            .on(MerlinGalleryUtils.pointerEventType, 'div.thumbnail-box', (e, oldEvent) => {
                var index = this.thumbnailsList.indexOf($(e.target).attr('src'));

                if (oldEvent) {
                    oldEvent.stopPropagation();
                    oldEvent.preventDefault();
                }

                if (this.$lastGalleryImage) {
                    this.$lastGalleryImage.removeClass('active');
                }

                this.$galleryImage.attr('src', this.previewList[index]).parent().attr('data-index', index);
                this.$lastGalleryImage = $(e.target).parent().addClass('active');

                this.checkButtonsState();
            })
            .on(MerlinGalleryUtils.pointerEventType, '.gallery-button', (e, oldEvent) => {
                if (oldEvent) {
                    oldEvent.stopPropagation();
                    oldEvent.preventDefault();
                }

                if (this.$galleryScrollPane.is(':animated')) return;

                var $target = $(e.target);
                if (!$target.is('.gallery-button'))
                    $target = $target.closest('.gallery-button');

                this.scrollGallery($target.find('i').is('.fa-angle-left'));
            });
        if (MerlinGalleryUtils.pointerEventType == 'tap') {
            this.$galleryContainer
                .on('touchstart touchmove touchend', function (e) {
                    e.preventDefault();
                })
                .on('swipe', (e) => {
                    if (e['direction'] === 'left') {
                        this.scrollGallery(false);
                    }
                    else if (e['direction'] === 'right') {
                        this.scrollGallery(true);
                    }
                });
        }

        this.$navBtnLeft.on(MerlinGalleryUtils.pointerEventType, this.prevImage.bind(this));
        this.$navBtnRight.on(MerlinGalleryUtils.pointerEventType, this.nextImage.bind(this));

        this.checkButtonsState();
        this.swipeSupport();
    }

    private swipeSupport(): void {
        this.$galleryImageContainer
            .on('touchmove', (e) => {
                e.preventDefault();
            }).on('swipe', (e) => {
            if (e['direction'] === 'left') {
                this.nextImage(null, null);
            }
            else if (e['direction'] === 'right') {
                this.prevImage(null, null);
            }
        });

        this.$galleryContainer.find('.gallery-scroll-pane')
            .on('touchmove', (e) => {
                e.preventDefault();
            })
            .on('swipe', (e) => {
                if (e['direction'] === 'left') {
                    this.scrollGallery(false);
                }
                else if (e['direction'] === 'right') {
                    this.scrollGallery(true);
                }
            });
    }

    private checkButtonsState(onLoad: boolean = false): void {
        let imagesOnScreen: number = Math.floor(this.$galleryContent.width() / this.totalThumbWidth);
        let firstThumbPosition: number = this.$galleryScrollPane.scrollLeft() == 0 ? this.$galleryContent.children('.thumbnail-box').first().offset().left : this.$galleryContent.children('.thumbnail-box').first().offset().left + this.$galleryScrollPane.scrollLeft();
        let displacement: number = imagesOnScreen * this.totalThumbWidth + firstThumbPosition;

        let activeFromLeft = this.$galleryContainer.find('div.active ').offset();

        if (activeFromLeft) {
            let tmp = activeFromLeft.left;
            if (tmp > displacement) {
                this.scrollGallery(false);
            }
            else if (tmp < 0 || tmp < firstThumbPosition) {
                this.scrollGallery(true);
            }
            setTimeout(() => {
                let index: number = parseInt(this.$galleryImageContainer.attr('data-index'));
                if (!index || index <= 0) {
                    this.$navBtnLeft.children().addClass('disabled');
                } else if (this.$navBtnLeft.children().hasClass('disabled')) {
                    this.$navBtnLeft.children().removeClass('disabled')
                }

                let galleryLength = this.$galleryContent.find('img').length;
                if (index >= galleryLength - 1) {
                    this.$navBtnRight.children().addClass('disabled');
                } else if (this.$navBtnRight.children().hasClass('disabled')) {
                    this.$navBtnRight.children().removeClass('disabled')
                }
            }, 200);
        }

    }

    private nextImage(e, oldEvent): void {
        var index: number = parseInt(this.$galleryImageContainer.attr('data-index'));
        if (!index) index = 0;
        let galleryLength = this.$galleryContent.find('div.thumbnail-box').length;
        if (index >= galleryLength - 1) return;

        if (oldEvent) {
            oldEvent.stopPropagation();
            oldEvent.preventDefault();
        }
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        if (this.$lastGalleryImage) this.$lastGalleryImage.removeClass('active');

        this.$spinner.fadeIn(0);
        this.$galleryContainer.before(this.$spinner);

        this.changeImage(index + 1);

        this.$lastGalleryImage = this.$galleryScrollPane.find('img').eq(index + 1).parent().addClass('active');

        this.checkButtonsState();
    }

    private prevImage(e, oldEvent): void {
        var index: number = parseInt(this.$galleryImageContainer.attr('data-index'));
        if (!index || index <= 0) return;

        if (oldEvent) {
            oldEvent.stopPropagation();
            oldEvent.preventDefault();
        }

        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        if (this.$lastGalleryImage) {
            this.$lastGalleryImage.removeClass('active');
        }

        this.$spinner.fadeIn(0);
        this.$galleryContainer.before(this.$spinner);

        this.changeImage(index - 1);

        this.$lastGalleryImage = this.$galleryScrollPane.find('img').eq(index - 1).parent().addClass('active');

        this.checkButtonsState();
    }

    private changeImage(index){
        this.$galleryImageContainer.fadeTo(0, 0, () => {
            this.$galleryImage.attr('src', this.previewList[index]);
            this.$galleryImageContainer.attr('data-index', index);

            this.$galleryImage
                .one('load', () => {
                    this.$galleryImageContainer.fadeTo(0, 1);

                    this.$spinner.fadeOut(0, () => {
                        this.$spinner.detach();
                    });
                })
                .one('error', () => {
                    Infomessage({
                        title: translations['info'],
                        mainText: translations['galleryConnectionError'],
                    });
                });
        });
    }

    private scrollGallery(scrollLeft: boolean): void {
        var lastPos = this.$galleryScrollPane.scrollLeft();
        var imagesOnScreen: number = Math.floor(this.$galleryContent.width() / this.totalThumbWidth);
        var displacement: number = imagesOnScreen * this.totalThumbWidth;

        this.galleryViewWidth = this.$galleryContent.width() - this.totalThumbWidth;

        if (scrollLeft) {
            if (this.$galleryNavBtnRight.is('.disabled'))
                displacement -= this.$galleryScrollPane.width() - imagesOnScreen * this.totalThumbWidth + this.thumbMargin;

            if (this.$galleryScrollPane.scrollLeft() - this.galleryViewWidth <= this.totalThumbWidth)
                this.$galleryNavBtnLeft.addClass('disabled');

            this.$galleryNavBtnRight.removeClass('disabled');

            this.$galleryScrollPane.animate({scrollLeft: this.$galleryScrollPane.scrollLeft() - displacement}, {
                duration: 300,
                queue: false
            });
        }
        else {
            if (this.$galleryScrollPane.scrollLeft() + displacement >= this.galleryLength - displacement - this.totalThumbWidth)
                this.$galleryNavBtnRight.addClass('disabled');

            this.$galleryNavBtnLeft.removeClass('disabled');

            this.$galleryScrollPane.animate({scrollLeft: this.$galleryScrollPane.scrollLeft() + displacement}, {
                duration: 300,
                queue: false
            });
        }
    }
}

class MerlinFullscreenContentGallery {
    private $spinner: JQuery = $(MerlinGalleryUtils.spinner);

    private $galleryImageContainer: JQuery = $('<div class="mg-fs-image-container big-image text-center">');
    private $galleryImage: JQuery = $('<img>');
    private $tmpImage: JQuery = $('<img>');
    private $galleryContainer: JQuery;
    private targetElement: number;
    private $eventTarget: JQuery;
    private $galleryScrollPane: JQuery = $('<div class="gallery-scroll-pane">');
    private $galleryContent: JQuery = $('<div class="gallery-content">');
    private $galleryNavBtnLeft: JQuery = $(MerlinGalleryUtils.navBtnLeft).addClass('fa-2x').css('left', '4px');
    private $galleryNavBtnRight: JQuery = $(MerlinGalleryUtils.navBtnRight).addClass('fa-2x').css('right', '4px');
    private $lastGalleryImage: JQuery;
    private lastFsImageWidth: number;
    private lastFsImageHeight: number;
    private $bottomGalleryContainer: JQuery = $('<div class="bottom-gallery-container">');
    private spinnerTimeout;

    private galleryViewWidth: number;
    private galleryLength: number;
    private previewList: Array<string>;
    private thumbnailsList: Array<string>;
    private thumbWidth: number = 160;
    private thumbMargin: number = 8;
    private totalThumbWidth: number = this.thumbWidth + this.thumbMargin;
    private uid: number = Math.floor(Math.random() * 26) + Date.now();

    private $closeBtn: JQuery = $('<i class="btn-gallery-close fa fa-times fa-3x text-color-5"></i>');
    private $fsContainer: JQuery = $('<div id="merlin-gallery-fullscreen"></div>').attr('data-id', this.uid);
    private $fsNavBtnLeft: JQuery = $(MerlinGalleryUtils.btnWrapper).addClass('pull-left').append($(MerlinGalleryUtils.navBtnLeft).addClass('fa-3x').css('left', '15px'));
    private $fsNavBtnRight: JQuery = $(MerlinGalleryUtils.btnWrapper).addClass('pull-right').append($(MerlinGalleryUtils.navBtnRight).addClass('fa-3x').css('right', '15px'));

    //binded handlers
    private keyDownHandlerFunction = this.keyDownHandler.bind(this);

    constructor($galleryElement: JQuery, $eventTarget: JQuery, targetElement: number = 0) {
        this.$galleryContainer = $galleryElement;
        this.targetElement = targetElement;
        this.$eventTarget = $eventTarget;
        this.$galleryImageContainer.append(this.$galleryImage);
        this.$bottomGalleryContainer.append(this.$galleryNavBtnLeft.addClass('disabled'), this.$galleryNavBtnRight, this.$galleryScrollPane.append(this.$galleryContent));
        this.$galleryContainer.append(this.$bottomGalleryContainer);

        this.$galleryContainer.before(this.$spinner, this.$galleryImageContainer).show().parent().addClass('merlin-gallery-container');
        this.$fsContainer.append(this.$closeBtn, this.$galleryContainer.parent(), this.$fsNavBtnLeft, this.$fsNavBtnRight);
    }

    public loadGallery(imgList: Array<string>): void {
        clearTimeout(this.spinnerTimeout);
        this.spinnerTimeout = setTimeout(() => {
			this.$galleryImageContainer.append(this.$spinner);
        }, 200);

        var $allElements = $();
        $.each(imgList, function (index, element) {
            $allElements = $allElements.add('<img src="' + element + '"/>');
        });

        this.galleryViewWidth = this.$galleryContent.width();
        this.$lastGalleryImage = $allElements.eq(this.targetElement).addClass('active');
        this.$galleryContent.empty().append($allElements);
        this.galleryLength = imgList.length * 170;

        this.$tmpImage.attr('src', $allElements[this.targetElement]['src']);
        if (this.galleryLength - this.galleryViewWidth > 0)
            this.$galleryNavBtnLeft.add(this.$galleryNavBtnRight).show();
        this.$galleryImageContainer.attr('data-index', this.targetElement);

        this.previewList = imgList;
        this.thumbnailsList = imgList;

        this.showFullscreen();
        this.addGalleryListeners();

        this.$tmpImage.unbind('load').load(() => {
            clearTimeout(this.spinnerTimeout);

            this.$spinner.detach();
            this.$galleryImageContainer.append(this.$tmpImage);
            this.$galleryImage = this.$tmpImage;
            this.lastFsImageWidth = this.$tmpImage.width();
            this.lastFsImageHeight = this.$tmpImage.height();
        });
    }

    private showFullscreen(): void {
        $(document).trigger('popupOn');
        $(window).on('keydown', this.keyDownHandlerFunction);

        $('body').append(this.$fsContainer).css('overflow', 'hidden');

        this.$fsContainer.on(MerlinGalleryUtils.pointerEventType, (e, oldEvent) => {
            if (oldEvent) {
                oldEvent.stopPropagation();
                oldEvent.preventDefault();
            }

            if ($(e.target).is('.btn-gallery-close')) {
                this.hideGallery();
            }

        });
        this.checkButtonsState(true);

        this.$fsNavBtnLeft.on(MerlinGalleryUtils.pointerEventType, this.prevImage.bind(this));
        this.$fsNavBtnRight.on(MerlinGalleryUtils.pointerEventType, this.nextImage.bind(this));
        this.$galleryImageContainer.on(MerlinGalleryUtils.pointerEventType, this.nextImage.bind(this));

        this.swipeSupport();
    }

    private swipeSupport(): void {
        this.$galleryImageContainer
            .on('touchstart touchmove touchend', (e) => {
                e.preventDefault();
            }).on('swipe', (e) => {
            if (e['direction'] === 'left') {
                this.nextImage(null, null);
            }
            else if (e['direction'] === 'right') {
                this.prevImage(null, null);
            }
        });

        this.$galleryContainer
            .on('touchstart touchmove touchend', (e) => {
                e.preventDefault();
            })
            .on('swipe', (e) => {
                if (e['direction'] === 'left') {
                    this.scrollGallery(false, null);
                }
                else if (e['direction'] === 'right') {
                    this.scrollGallery(true, null);
                }
            });
    }

    private checkButtonsState(onLoad: boolean = false): void {
        let imagesOnScreen: number = Math.floor(this.$galleryContent.width() / this.totalThumbWidth);
        let displacement: number = imagesOnScreen * this.totalThumbWidth;
        let activeFromLeft = this.$galleryContainer.find('img.active').offset().left;

        if (activeFromLeft > displacement) {
            onLoad ? this.scrollGallery(false, activeFromLeft) : this.scrollGallery(false, null);
        }
        else if (activeFromLeft < 0) {
            onLoad ? this.scrollGallery(true, activeFromLeft) : this.scrollGallery(true, null);
        }
        setTimeout(() => {
            let index: number = parseInt(this.$galleryImageContainer.attr('data-index'));
            if (!index || index <= 0) {
                this.$fsNavBtnLeft.children().addClass('disabled');
            } else if (this.$fsNavBtnLeft.children().hasClass('disabled')) {
                this.$fsNavBtnLeft.children().removeClass('disabled')
            }

            let galleryLength = this.$galleryContent.find('img').length;
            if (index >= galleryLength - 1) {
                this.$fsNavBtnRight.children().addClass('disabled');
            } else if (this.$fsNavBtnRight.children().hasClass('disabled')) {
                this.$fsNavBtnRight.children().removeClass('disabled')
            }
        }, 200);
    }

    private nextImage(e, oldEvent): void {
        var index: number = parseInt(this.$galleryImageContainer.attr('data-index'));
        if (!index) index = 0;
        let galleryLength = this.$galleryContent.find('img').length;
        if (index >= galleryLength - 1) return;

        if (oldEvent) {
            oldEvent.stopPropagation();
            oldEvent.preventDefault();
        }
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }


        if (this.$lastGalleryImage) this.$lastGalleryImage.removeClass('active');
		let that = this;
		this.$galleryImageContainer.fadeOut(150, function(){
			that.$galleryImageContainer.fadeIn(150);
			that.$galleryImage.attr('src', that.previewList[index+1]).parent().attr('data-index', index+1);
        });

        this.$lastGalleryImage = this.$galleryScrollPane.find('img').eq(index + 1).addClass('active');

        this.checkButtonsState();
    }

    private prevImage(e, oldEvent): void {
        var index: number = parseInt(this.$galleryImageContainer.attr('data-index'));
        if (!index || index <= 0) return;


        if (oldEvent) {
            oldEvent.stopPropagation();
            oldEvent.preventDefault();
        }

        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        if (this.$lastGalleryImage) this.$lastGalleryImage.removeClass('active');

		let that = this;
		this.$galleryImageContainer.fadeOut(150, function(){
			that.$galleryImageContainer.fadeIn(150);
			that.$galleryImage.attr('src', that.previewList[index-1]).parent().attr('data-index', index-1);
        });

        this.$lastGalleryImage = this.$galleryScrollPane.find('img').eq(index - 1).addClass('active');

        this.checkButtonsState();

    }

    private hideGallery(): void {
        $(document).trigger('popupOff');
        this.$fsContainer.hide();
        this.$galleryImageContainer.hide();
        $('body').css('overflow', '');
    }

    private addGalleryListeners(): void {
        this.$galleryContainer
            .on(MerlinGalleryUtils.pointerEventType, 'img', (e, oldEvent) => {
                var index = this.thumbnailsList.indexOf($(e.target).attr('src'));

                if (oldEvent) {
                    oldEvent.stopPropagation();
                    oldEvent.preventDefault();
                }
                if (this.$lastGalleryImage) this.$lastGalleryImage.removeClass('active');

				let that = this;
				this.$galleryImageContainer.fadeOut(150, function(){
					that.$galleryImageContainer.fadeIn(150);
					that.$galleryImage.attr('src', that.previewList[index]).parent().attr('data-index', index);
                });
                this.$lastGalleryImage = $(e.target).addClass('active');

                this.checkButtonsState();
            })
            .on(MerlinGalleryUtils.pointerEventType, '.gallery-button', (e, oldEvent) => {
                if (oldEvent) {
                    oldEvent.stopPropagation();
                    oldEvent.preventDefault();
                }

                if (this.$galleryScrollPane.is(':animated')) return;

                var $target = $(e.target);
                if (!$target.is('.gallery-button'))
                    $target = $target.closest('.gallery-button');

                this.scrollGallery($target.find('i').is('.fa-angle-left'), null);
            });

        this.$eventTarget.on(MerlinGalleryUtils.pointerEventType, (e) => {
            $(document).trigger('popupOn');
            if (this.targetElement) {
                $('.gallery-content').find('img').eq($(e.target).parent().index()).trigger('click');
            }
            $('[data-id="' + this.uid + '"]').show();
            $('body').css('overflow', 'hidden');
            this.$galleryImageContainer.show();
            this.checkButtonsState(true);
        });

        if (MerlinGalleryUtils.pointerEventType == 'tap') {
            this.$galleryContainer
                .on('touchstart touchmove touchend', function (e) {
                    e.preventDefault();
                })
                .on('swipe', (e) => {
                    if (e['direction'] === 'left') {
                        this.scrollGallery(false, null);
                    }
                    else if (e['direction'] === 'right') {
                        this.scrollGallery(true, null);
                    }
                });
        }
    }

    private scrollGallery(scrollLeft: boolean, elemLeftOffset: number): void {
        var imagesOnScreen: number = Math.floor(this.$galleryContent.width() / this.totalThumbWidth);
        var displacement: number = imagesOnScreen * this.totalThumbWidth;

        this.galleryViewWidth = this.$galleryContent.width() - this.totalThumbWidth;

        if (scrollLeft) {
            if (this.$galleryNavBtnRight.is('.disabled'))
                displacement -= this.$galleryScrollPane.width() - imagesOnScreen * this.totalThumbWidth + this.thumbMargin;

            if (this.$galleryScrollPane.scrollLeft() - this.galleryViewWidth <= this.totalThumbWidth)
                this.$galleryNavBtnLeft.addClass('disabled');

            this.$galleryNavBtnRight.removeClass('disabled');

            if (elemLeftOffset) {
                this.$galleryScrollPane.animate({scrollLeft: elemLeftOffset + this.$galleryScrollPane.scrollLeft() + window.innerWidth / 2 - displacement}, {
                    duration: 300,
                    queue: false
                });
                return;
            }

            this.$galleryScrollPane.animate({scrollLeft: this.$galleryScrollPane.scrollLeft() - displacement}, {
                duration: 300,
                queue: false
            });
        }
        else {
            if (this.$galleryScrollPane.scrollLeft() + displacement >= this.galleryLength - displacement - this.totalThumbWidth)
                this.$galleryNavBtnRight.addClass('disabled');

            this.$galleryNavBtnLeft.removeClass('disabled');

            if (elemLeftOffset) {
                this.$galleryScrollPane.animate({scrollLeft: elemLeftOffset + this.$galleryScrollPane.scrollLeft() + window.innerWidth / 2 - displacement}, {
                    duration: 300,
                    queue: false
                });

                return;
            }

            this.$galleryScrollPane.animate({scrollLeft: this.$galleryScrollPane.scrollLeft() + displacement}, {
                duration: 300,
                queue: false
            });
        }
    }

    private keyDownHandler(e): void {
        if (this.$fsContainer.is(':hidden'))
            return;

        var key = e.which;
        if (key == 37) {
            this.prevImage(null, null);
        }
        else if (key == 39) {
            this.nextImage(null, null);
        }
        else if (key == 27) {
            this.hideGallery();
        }
    }
}

class GalleryFullscreenContentGallery {
    private $spinner: JQuery = $(MerlinGalleryUtils.spinner);

    private $galleryImageContainer: JQuery = $('<div class="mg-fs-image-container big-image text-center">');
    private $galleryImage: JQuery = $('<img>');
    private $tmpImage: JQuery = $('<img>');
    private $galleryContainer: JQuery;
    private targetElement: number;
    private titles;
    private $eventTarget: JQuery;
    private $galleryScrollPane: JQuery = $('<div class="gallery-scroll-pane">');
    private $galleryContent: JQuery = $('<div class="gallery-content">');
    private $galleryNavBtnLeft: JQuery = $(MerlinGalleryUtils.navBtnLeft).addClass('fa-2x').css('left', '6px');
    private $galleryNavBtnRight: JQuery = $(MerlinGalleryUtils.navBtnRight).addClass('fa-2x').css('right', '6px');
    private $lastGalleryImage: JQuery;
    private lastFsImageWidth: number;
    private lastFsImageHeight: number;
    private $bottomGalleryContainer: JQuery = $('<div class="bottom-gallery-container">');
    private spinnerTimeout;

    private galleryViewWidth: number;
    private galleryLength: number;
    private previewList: Array<string>;
    private thumbnailsList: Array<string>;
    private thumbWidth: number = 160;
    private thumbMargin: number = 8;
    private totalThumbWidth: number = this.thumbWidth + this.thumbMargin;
    private uid: number = Math.floor(Math.random() * 26) + Date.now();

    private $closeBtn: JQuery = $('<i class="btn-gallery-close fa fa-times fa-3x text-color-5"></i>');
    private $fsContainer: JQuery = $('<div id="merlin-gallery-fullscreen"></div>').attr('data-id', this.uid);
    private $fsNavBtnLeft: JQuery = $(MerlinGalleryUtils.btnWrapper).addClass('pull-left').append($(MerlinGalleryUtils.navBtnLeft).addClass('fa-3x').css('left', '15px'));
    private $fsNavBtnRight: JQuery = $(MerlinGalleryUtils.btnWrapper).addClass('pull-right').append($(MerlinGalleryUtils.navBtnRight).addClass('fa-3x').css('right', '15px'));

    //binded handlers
    private keyDownHandlerFunction = this.keyDownHandler.bind(this);

    constructor($galleryElement: JQuery, $eventTarget: JQuery, targetElement: number = 1) {
        this.$galleryContainer = $galleryElement;
        this.targetElement = targetElement;
        this.$eventTarget = $eventTarget;
        this.$galleryImageContainer.append(this.$galleryImage);
        this.$bottomGalleryContainer.append(this.$galleryNavBtnLeft.addClass('disabled'), this.$galleryNavBtnRight, this.$galleryScrollPane.append(this.$galleryContent));
        this.$galleryContainer.append(this.$bottomGalleryContainer);

        this.$galleryContainer.before(this.$spinner, this.$galleryImageContainer).show().parent().addClass('merlin-gallery-container');
        this.$fsContainer.append(this.$closeBtn, this.$galleryContainer.parent(), this.$fsNavBtnLeft, this.$fsNavBtnRight);
    }

    public loadGallery(imgList: Array<string>, titlesArray: Array<string>): void {
        this.titles = titlesArray;
        clearTimeout(this.spinnerTimeout);
        this.spinnerTimeout = setTimeout(() => {
            this.$galleryImageContainer.append(this.$spinner);
        }, 200);

        var $allElements = $();

        $.each(imgList, function (index, element) {
            const title = `${titlesArray[index]}`;
            $allElements = $allElements.add('<img src="' + element + '" data-title="' + title + '"/>');
        });

        this.galleryViewWidth = this.$galleryContent.width();
        this.$lastGalleryImage = $allElements.eq(this.targetElement).addClass('active');
        this.$galleryContent.empty().append($allElements);
        this.galleryLength = imgList.length * 170;

        this.$tmpImage.attr('src', $allElements[this.targetElement]['src']);
        if (this.galleryLength - this.galleryViewWidth > 0)
            this.$galleryNavBtnLeft.add(this.$galleryNavBtnRight).show();
        this.$galleryImageContainer.attr('data-index', this.targetElement);

        this.previewList = imgList;
        this.thumbnailsList = imgList;

        this.showFullscreen();
        this.addGalleryListeners();

        this.$tmpImage.unbind('load').load(() => {
            clearTimeout(this.spinnerTimeout);
            const title = titlesArray[this.targetElement];

            this.$spinner.detach();

            this.$galleryImageContainer.append(this.$tmpImage);
            if (!this.$galleryImageContainer.find('.img-title').length) {
                this.$galleryImageContainer.prepend(`<div class="img-title">${title}</div>`);
            }

            this.$galleryImage = this.$tmpImage;
            this.lastFsImageWidth = this.$tmpImage.width();
            this.lastFsImageHeight = this.$tmpImage.height();
        });
    }

    private showFullscreen(): void {
        $(window).on('keydown', this.keyDownHandlerFunction);

        $('body').append(this.$fsContainer).css('overflow', 'hidden');

        this.$fsContainer.on(MerlinGalleryUtils.pointerEventType, (e, oldEvent) => {
            if (oldEvent) {
                oldEvent.stopPropagation();
                oldEvent.preventDefault();
            }

            if ($(e.target).is('.btn-gallery-close')) {
                this.hideGallery();
            }

            if ($(e.target).closest('.bottom-gallery-container').length || $(e.target).closest('.mg-btn-container').length || $(e.target).closest('.mg-fs-image-container').length) {
                e.preventDefault();
                e.stopPropagation();
            }
            else {
                this.hideGallery();
            }
        });
        this.checkButtonsState(true);

        this.$fsNavBtnLeft.on(MerlinGalleryUtils.pointerEventType, this.prevImage.bind(this));
        this.$fsNavBtnRight.on(MerlinGalleryUtils.pointerEventType, this.nextImage.bind(this));
        this.$galleryImageContainer.on(MerlinGalleryUtils.pointerEventType, this.nextImage.bind(this));

        this.swipeSupport();
    }

    private swipeSupport(): void {
        this.$galleryImageContainer
            .on('touchstart touchmove touchend', (e) => {
                e.preventDefault();
            }).on('swipe', (e) => {
            if (e['direction'] === 'left') {
                this.nextImage(null, null);
            }
            else if (e['direction'] === 'right') {
                this.prevImage(null, null);
            }
        });

        this.$galleryContainer
            .on('touchstart touchmove touchend', (e) => {
                e.preventDefault();
            })
            .on('swipe', (e) => {
                if (e['direction'] === 'left') {
                    this.scrollGallery(false, null);
                }
                else if (e['direction'] === 'right') {
                    this.scrollGallery(true, null);
                }
            });
    }

    private checkButtonsState(onLoad: boolean = false): void {
        let imagesOnScreen: number = Math.floor(this.$galleryContent.width() / this.totalThumbWidth);
        let displacement: number = imagesOnScreen * this.totalThumbWidth;

        let activeFromLeft = this.$galleryContainer.find('img.active').offset();

        if (activeFromLeft) {
            let tmp = activeFromLeft.left;
            if (tmp > displacement) {
                onLoad ? this.scrollGallery(false, tmp) : this.scrollGallery(false, null);
            }
            else if (tmp < 0) {
                onLoad ? this.scrollGallery(true, tmp) : this.scrollGallery(true, null);
            }
            setTimeout(() => {
                let index: number = parseInt(this.$galleryImageContainer.attr('data-index'));
                if (!index || index <= 0) {
                    this.$fsNavBtnLeft.children().addClass('disabled');
                } else if (this.$fsNavBtnLeft.children().hasClass('disabled')) {
                    this.$fsNavBtnLeft.children().removeClass('disabled')
                }

                let galleryLength = this.$galleryContent.find('img').length;
                if (index >= galleryLength - 1) {
                    this.$fsNavBtnRight.children().addClass('disabled');
                } else if (this.$fsNavBtnRight.children().hasClass('disabled')) {
                    this.$fsNavBtnRight.children().removeClass('disabled')
                }
            }, 200);
        }

    }

    private nextImage(e, oldEvent): void {
        var index: number = parseInt(this.$galleryImageContainer.attr('data-index'));
        if (!index) index = 0;
        let galleryLength = this.$galleryContent.find('img').length;
        if (index >= galleryLength - 1) return;

        let title = this.titles[index + 1];
        if (title) {
            $(this.$galleryImageContainer).find('.img-title').text(title);
        } else {
            $(this.$galleryImageContainer).find('.img-title').text('');
        }

        if (oldEvent) {
            oldEvent.stopPropagation();
            oldEvent.preventDefault();
        }
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        if (this.$lastGalleryImage) this.$lastGalleryImage.removeClass('active');
        let that = this;
        this.$galleryImageContainer.fadeOut(150, function () {
            that.$galleryImageContainer.fadeIn(150);
            that.$galleryImage.attr('src', that.previewList[index + 1]).parent().attr('data-index', index + 1);
        });

        this.$lastGalleryImage = this.$galleryScrollPane.find('img').eq(index + 1).addClass('active');

        this.checkButtonsState();
    }

    private prevImage(e, oldEvent): void {
        var index: number = parseInt(this.$galleryImageContainer.attr('data-index'));
        if (!index || index <= 0) return;

        let title = this.titles[index - 1];
        if (title) {
            $(this.$galleryImageContainer).find('.img-title').text(title);
        } else {
            $(this.$galleryImageContainer).find('.img-title').text('');
        }

        if (oldEvent) {
            oldEvent.stopPropagation();
            oldEvent.preventDefault();
        }

        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        if (this.$lastGalleryImage) {
            this.$lastGalleryImage.removeClass('active');
        }

        let that = this;
        this.$galleryImageContainer.fadeOut(150, function () {
            that.$galleryImageContainer.fadeIn(150);
            that.$galleryImage.attr('src', that.previewList[index - 1]).parent().attr('data-index', index - 1);
        });

        this.$lastGalleryImage = this.$galleryScrollPane.find('img').eq(index - 1).addClass('active');
        this.checkButtonsState();
    }

    private hideGallery(): void {
        this.$fsContainer.detach();
        this.$galleryImageContainer.remove();
        $('body').css('overflow', '');
    }

    private addGalleryListeners(): void {
        this.$galleryContainer
            .on(MerlinGalleryUtils.pointerEventType, 'img', (e, oldEvent) => {
                var index = this.thumbnailsList.indexOf($(e.target).attr('src'));
                var title = $(e.target).attr('data-title');

                if (title) {
                    $(this.$galleryImageContainer).find('.img-title').text(title);
                }

                if (oldEvent) {
                    oldEvent.stopPropagation();
                    oldEvent.preventDefault();
                }
                if (this.$lastGalleryImage) this.$lastGalleryImage.removeClass('active');

                let that = this;
                this.$galleryImageContainer.fadeOut(150, function () {
                    that.$galleryImageContainer.fadeIn(150);
                    that.$galleryImage.attr('src', that.previewList[index]).parent().attr('data-index', index);
                });
                this.$lastGalleryImage = $(e.target).addClass('active');

                this.checkButtonsState();
            })
            .on(MerlinGalleryUtils.pointerEventType, '.gallery-button', (e, oldEvent) => {
                if (oldEvent) {
                    oldEvent.stopPropagation();
                    oldEvent.preventDefault();
                }

                if (this.$galleryScrollPane.is(':animated')) return;

                var $target = $(e.target);
                if (!$target.is('.gallery-button'))
                    $target = $target.closest('.gallery-button');

                this.scrollGallery($target.find('i').is('.fa-angle-left'), null);
            });
        if (MerlinGalleryUtils.hasOwnProperty('pointerEventType') && this.$eventTarget) {
            this.$eventTarget.on(MerlinGalleryUtils.pointerEventType, (e) => {
                if (this.targetElement) {
                    $('.gallery-content').find('img').eq($(e.target).parent().index()).trigger('click');
                }
                $('[data-id="' + this.uid + '"]').show();
                $('body').css('overflow', 'hidden');
                this.checkButtonsState(true);
            });
        }


        if (MerlinGalleryUtils.pointerEventType == 'tap') {
            this.$galleryContainer
                .on('touchstart touchmove touchend', function (e) {
                    e.preventDefault();
                })
                .on('swipe', (e) => {
                    if (e['direction'] === 'left') {
                        this.scrollGallery(false, null);
                    }
                    else if (e['direction'] === 'right') {
                        this.scrollGallery(true, null);
                    }
                });
        }
    }

    private scrollGallery(scrollLeft: boolean, elemLeftOffset: number): void {
        var imagesOnScreen: number = Math.floor(this.$galleryContent.width() / this.totalThumbWidth);
        var displacement: number = imagesOnScreen * this.totalThumbWidth;

        this.galleryViewWidth = this.$galleryContent.width() - this.totalThumbWidth;

        if (scrollLeft) {
            if (this.$galleryNavBtnRight.is('.disabled'))
                displacement -= this.$galleryScrollPane.width() - imagesOnScreen * this.totalThumbWidth + this.thumbMargin;

            if (this.$galleryScrollPane.scrollLeft() - this.galleryViewWidth <= this.totalThumbWidth)
                this.$galleryNavBtnLeft.addClass('disabled');

            this.$galleryNavBtnRight.removeClass('disabled');

            if (elemLeftOffset) {
                this.$galleryScrollPane.animate({scrollLeft: elemLeftOffset + this.$galleryScrollPane.scrollLeft() + window.innerWidth / 2 - displacement}, {
                    duration: 300,
                    queue: false
                });
                return;
            }

            this.$galleryScrollPane.animate({scrollLeft: this.$galleryScrollPane.scrollLeft() - displacement}, {
                duration: 300,
                queue: false
            });
        }
        else {
            if (this.$galleryScrollPane.scrollLeft() + displacement >= this.galleryLength - displacement - this.totalThumbWidth)
                this.$galleryNavBtnRight.addClass('disabled');

            this.$galleryNavBtnLeft.removeClass('disabled');

            if (elemLeftOffset) {
                this.$galleryScrollPane.animate({scrollLeft: elemLeftOffset + this.$galleryScrollPane.scrollLeft() + window.innerWidth / 2 - displacement}, {
                    duration: 300,
                    queue: false
                });

                return;
            }

            this.$galleryScrollPane.animate({scrollLeft: this.$galleryScrollPane.scrollLeft() + displacement}, {
                duration: 300,
                queue: false
            });
        }
    }

    private keyDownHandler(e): void {
        if (this.$fsContainer.is(':hidden'))
            return;

        var key = e.which;
        if (key == 37) {
            this.prevImage(null, null);
        }
        else if (key == 39) {
            this.nextImage(null, null);
        }
        else if (key == 27) {
            this.hideGallery();
        }
    }
}


class MerlinGalleryUtils {
    public static btnWrapper: string = '<div class="mg-btn-container">';
    public static navBtnLeft: string = '<div class="btn br-btn background-color-7 text-color-15 background-hover-18 gallery-button"><i class="fa fa-angle-left"></i></div>';
    public static navBtnRight: string = '<div class="btn br-btn background-color-7 text-color-15 background-hover-18 gallery-button"><i class="fa fa-angle-right"></i></div>';
    public static spinner: string = '<i class="spinner fa fa-spinner fa-4x fa-spin" >';
    public static zoomInBtn: string = '<i class="btn-zoom-in fa fa-search-plus" style="display:none">';
    public static pointerEventType: string = ((window.navigator.msMaxTouchPoints || 'ontouchstart' in window) ? 'tap click' : 'click');
}
